import { Injectable, inject } from '@angular/core';
import { IgniteService } from '@clubhub/ignite/services';
import { CriteriaType, OutcomeResponse, OutcomeResponseContextResult } from '@shared/models';
import { AuthorizeService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class CriteriaChecksService {
  private readonly igniteService = inject(IgniteService);
  private readonly authService = inject(AuthorizeService);

  public get canDelete(): boolean {
    return this.authService.isLoggedIn;
  }

  public getOtherCriteriaOutcomes(additionalOutcome: OutcomeResponse | undefined): OutcomeResponseContextResult[] {
    return additionalOutcome?.contextResults.filter(
      (contextResult: OutcomeResponseContextResult) => !this.igniteService.applicantOutcomeIds?.includes(contextResult.outcomeId),
    ) ?? [];
  }

  public getOtherPropertyCriteriaOutcomes(propertyOutcome: OutcomeResponse | undefined): OutcomeResponseContextResult[] {
    return propertyOutcome?.contextResults.filter(
      (contextResult: OutcomeResponseContextResult) =>
        !this.igniteService.applicantOutcomeIds?.includes(contextResult.outcomeId) && contextResult.criteriaType !== CriteriaType.Intuitive,
    ) ?? [];
  }
}
